import { render, staticRenderFns } from "./SubscriptionGeneral.vue?vue&type=template&id=6f0ef9ac&"
import script from "./SubscriptionGeneral.vue?vue&type=script&lang=js&"
export * from "./SubscriptionGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports